export { default as ContentfulVideo } from './contentfulVideo'



// WEBPACK FOOTER //
// ./src/components/contentful/video/index.js